import { HOUR_HEIGHT_PX } from "../../utils/timeGrid";

interface TimeAxisProps {
  /** Pixel height of the tallest day column in the grid */
  heightPx: number;
}

/**
 * Sticky hour gutter for the time grid. Every column uses its date's local
 * wall clock on the same 48px/hour scale. Equal Y positions in columns with
 * different zones are intentionally not equal instants.
 */
export function TimeAxis({ heightPx }: TimeAxisProps) {
  const hours = Array.from({ length: 24 }, (_, hour) => hour);

  return (
    <div
      className="sticky left-0 z-10 bg-page relative"
      style={{ height: heightPx }}
      aria-hidden
    >
      {hours.map((hour) => (
        <span
          key={hour}
          className="absolute right-2 -translate-y-1/2 text-2xs font-semibold text-tertiary tabular-nums tracking-wide select-none"
          style={{ top: hour * HOUR_HEIGHT_PX }}
        >
          {hour === 0 ? "" : `${String(hour).padStart(2, "0")}:00`}
        </span>
      ))}
    </div>
  );
}
